<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 條件搜索 -->
       <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="投放開始時間" prop="beginTime">
                <a-range-picker format="YYYY-MM-DD" v-model="startRanges" @change="changeStart"></a-range-picker>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="投放結束時間" prop="endTime">
                <a-range-picker format="YYYY-MM-DD" v-model="endRanges" @change="changeEnd"></a-range-picker>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查詢</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete">
          <a-icon type="delete" />刪除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <browse
        ref="browse"
        @ok="getList"
      />
      <!-- 數據展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <img style="width: 48px;height: 48px;" preview="頭像" @click="imgShow(record.image)" :src="record.image" v-if="record.image != null && record.image != ''" slot="image" slot-scope="text, record">

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"/>
          <a @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical"/>
          <a @click="handleStatus(record,1)" v-if="record.status == 0">
            下架
          </a>
          <a @click="handleStatus(record,0)" v-if="record.status == 1">
            上架
          </a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)">
            <a-icon type="delete" />刪除
          </a>
          <a-divider type="vertical"v-if="record.skipType==3"/>
           <a @click="handlePreview(record)" v-if="record.skipType==3">
            <a-icon type="eye" />預覽
           </a>
           <a-divider type="vertical" />
          <a @click="$refs.browse.getList(record.id)">
            <a-icon type="search" />執行記錄
          </a>
        </span>
      </a-table>
      <!-- 預覽 -->
      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel" :width="600" :height="'100%'"
               style="top: 0; padding: 0;">
        <div v-html="previewContent"></div>
      </a-modal>
      <!-- 分頁 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 條`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageSlideshow,listSlideshow, delSlideshow,changeStatus } from '@/api/platform/slideshow'
import CreateForm from './modules/CreateForm'
import Browse from './modules/browse'
import { tableMixin } from '@/store/table-mixin'
import {imgShow} from "@/utils/ruoyi";

export default {
  name: 'Slideshow',
  components: {
    CreateForm,
    Browse
  },
  mixins: [tableMixin],
  data () {
    return {
      previewVisible: false,
      previewContent: null,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高級搜索 展開/關閉
      advanced: false,
      // 非單個禁用
      single: true,
      // 非多個禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      startRanges:[],
      endRanges:[],
      // 查詢參數
      queryParam: {
        placeType: null,
        skipType: null,
        business: null,
        resourceId: null,
        sort: null,
        beginStartTime: null,
        beginEndTime: null,
        endStartTime: null,
        endEndTime:null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '圖片',
          dataIndex: 'image',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: "image"}
        },
        // {
        //   title: '位置',
        //   dataIndex: 'placeType',
        //   ellipsis: true,
        //   align: 'center',
        //   customRender: function (value) {
        //     if (value == 1){
        //       return "賽事"
        //     }
        //     if (value == 2){
        //       return "刷手商城"
        //     }
        //     if (value == 3){
        //       return "商品分類"
        //     }
        //   }
        // },
        {
          title: '跳轉類型',
          dataIndex: 'skipType',
          ellipsis: true,
          align: 'center',
          customRender: function (value) {
            if (value == 1){
              return "無"
            }
            if (value == 2){
              return "跳轉鏈接"
            }
            if (value == 3){
              return "站內鏈接"
            }
            if (value == 4){
              return "跳轉"
            }
          }
        },
        // {
        //   title: '排序',
        //   dataIndex: 'sort',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '投放開始時間',
          dataIndex: 'beginTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '投放結束時間',
          dataIndex: 'endTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '建立時間',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    imgShow(imgUrl){
      imgShow(imgUrl);
    },
    handlePreview(record){
      this.previewContent = record.remark
      this.previewVisible = true
    },
    handleCancel() {
      this.previewContent = null
      this.previewVisible = false
    },
    /** 查詢輪播圖列表 */
    getList () {
      this.loading = true
     pageSlideshow(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleStatus(row,status){
      var that = this
      let tit = status == 1 ? '下架': '上架'
      this.$confirm({
        title: '確認'+tit+'所選中數據?',
        content: '當前選中編號為' + row.id + '的數據',
        onOk () {
          return changeStatus(row.id)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '操作成功',
                3
              )
            })
        },
        onCancel () {
          //取消清空刪除ids列表
          that.ids = []
        }
      })
    },

    changeStart(date, dateString) {
      console.log(dateString)
      this.queryParam.beginStartTime = dateString[0]+" 00:00:00";
      this.queryParam.beginEndTime = dateString[1]+" 23:59:59";
      //this.handleQuery();
    },


    changeEnd(date, dateString) {
      console.log(dateString)
      this.queryParam.endStartTime = dateString[0]+" 00:00:00";
      this.queryParam.endEndTime = dateString[1]+" 23:59:59";
      //this.handleQuery();
    },

    /** 搜索按鈕操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按鈕操作 */
    resetQuery () {
      this.queryParam = {
        placeType: undefined,
        skipType: undefined,
        business: undefined,
        resourceId: undefined,
        sort: undefined,
        beginStartTime: undefined,
        beginEndTime: undefined,
        endStartTime: undefined,
        endEndTime:undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.startRanges=[]
      this.endRanges = []
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 刪除按鈕操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '確認刪除所選中數據?',
        content: '當前選中編號為' + ids + '的數據',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delSlideshow(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '刪除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空刪除ids列表
          that.ids = []
        }
      })
    },
    /** 導出按鈕操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否確認導出?',
        content: '此操作將導出當前條件下所有數據而非選中數據',
        onOk () {
          that.download('platform/slideshow/export', {
            ...that.queryParam
          }, `輪播圖_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
